import template from './app.html';

// MODULE EXPORTS

export let AppComponent = {
  templateUrl: template,
  selector: 'app',
  bindings: {},
  controller: AppCtrl,
  controllerAs: 'vm'
};

AppCtrl.$inject = [];

function AppCtrl() {
}



// WEBPACK FOOTER //
// ./src/app.component.js